module.exports = __webpack_public_path__ + "static/img/MSOBC-CMRClogo-1.6fa607a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/MSOBC-CMRClogo-1.jpg
// module id = MzhY
// module chunks = 1